import { WebOddsType } from '@nf/utils-common/constants';
import { useBetslipContext } from '@/features/betslip/contexts/betslip-context';

export const useBookingOddsType = (priceType: number) => {
	const { oddsType } = useBetslipContext();
	const isConstrainedOddsType = [WebOddsType.MY, WebOddsType.DEC].includes(oddsType);
	const bookingOddsType = isConstrainedOddsType && priceType !== 1 ? oddsType : WebOddsType.DEC;

	return {
		isConstrainedOddsType,
		bookingOddsType
	};
};